
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputMouseGoogle as ObiInputMouseGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-mouse-google.js';
 
 
 

 
 export const ObiInputMouseGoogle = createComponent({
   react: React,
   tagName: 'obi-input-mouse-google',
   elementClass: ObiInputMouseGoogleElement,
   events: {
     
   }
  });
 
 